export enum ReferralAuthorizationTeStatus {
  REQUIRED = "required",
  NOT_REQUIRED = "not required",
  STATUS_UNKNOWN = "status unknown",
}

export enum ReferralAuthorizationWorkflowStatus {
  NOT_REQUIRED = "not required",
  PENDING = "pending",
  APPROVED = "approved",
  DENIED = "denied",
}
